import React, { Component } from "react";
import { Configurations } from "../../Utils/Configurations";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { SingleDatePicker } from "react-dates";
import Geral from '../../Utils/Geral';
import moment from 'moment';
import axios from "axios";


class ModalEditarEdicao extends Component {

    constructor(props) {
        super(props);
        this._outsideRange = this._outsideRange.bind(this);
        this.onDateChange = this.onDateChangeRedacao.bind(this);
        this.onDateChangeAssinatura = this.onDateChangeAssinatura.bind(this);
        this.onDateChangeEntrega = this.onDateChangeEntrega.bind(this);
        this.salvarDatas = this.salvarDatas.bind(this);
        this.handleError = this.handleError.bind(this);
        this.validarData = this.validarData.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            dtRedacao: this.props.edicao.dtRedacaoFechamento,
            dtAssinatura: this.props.edicao.dtLimiteAssinatura,
            dtEntrega: this.props.edicao.dtEntrega,
            isLoadingSalvarDatas: false,
            idEdicao: this.props.edicao.idEdicao
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.edicao !== prevProps.edicao) {
            this.setState({
                dtEntrega: this.props.edicao.dtEntrega,
                dtAssinatura: this.props.edicao.dtLimiteAssinatura,
                dtRedacao: this.props.edicao.dtRedacaoFechamento,
                idEdicao: this.props.edicao.idEdicao
            })
        }
    }

    _outsideRange(day) {
        return day.format() < moment().subtract(1, 'month').format();
    }

    onDateChangeRedacao(date) {
        this.setState({
            dtRedacao: date
        })
    }

    onDateChangeAssinatura(date) {
        this.setState({
            dtAssinatura: date,
        })
    }

    onDateChangeEntrega(date) {
        this.setState({
            dtEntrega: date,
        })
    }

    salvarDatas() {

        const _body = {
            idEdicao: this.state.idEdicao,
            dtEntrega: this.state.dtEntrega,
            dtLimiteAssinatura: this.state.dtAssinatura,
            dtRedacaoFechamento: this.state.dtRedacao
        }
        this.setState({ isLoadingSalvarDatas: true })

        axios.put(this.Configurations.apiBasePath + `/edicoes/assinatura/impressos`, _body).then(response => {

            this.props.toggle();
            this.props.carregaListaEdicoes({});
        }).catch(this.handleError).finally(() => this.setState({ isLoadingSalvarDatas: false }))
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: (!!err.response && !!err.response.data && !!err.response.data.message) ? err.response.data.message : 'Erro inesperado.' })
    }

    validarData() {
        const dataValidaAssinatura = moment(this.state.dtAssinatura).isValid();
        const dataValidaRedacao = moment(this.state.dtRedacao).isValid();
        const dataValidaEntrega = moment(this.state.dtEntrega).isValid();

        return !dataValidaAssinatura || !dataValidaRedacao || !dataValidaEntrega;

    }

    render() {
        const {
            isOpen,
            toggle,
            edicao
        } = this.props;

        return (
            <Modal className="modalEditar" size="lg" isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>Editar datas</ModalHeader>
                <ModalBody>
                    <div className="row no-gutters">
                        <div className="col-12 text-center">
                            <span>Edição: <strong>{edicao.numeroEdicao}</strong></span> - <span className={`badge badge-${Geral.obtemTipoBadge(edicao.sigla).badgeColor}`}>{edicao.sigla}</span>
                        </div>
                        <div className="col-4">
                            <label className="py-2">Data limite assinatura</label>
                            <SingleDatePicker
                                date={this.state.dtAssinatura !== null ? moment(this.state.dtAssinatura) : null} // momentPropTypes.momentObj or null
                                onDateChange={date => this.onDateChangeAssinatura(date)} // PropTypes.func.isRequired
                                focused={this.state.focusedAssinatura} // PropTypes.bool
                                onFocusChange={({ focused }) => this.setState({ focusedAssinatura: focused })} // PropTypes.func.isRequired
                                id="dtAssinatura" // PropTypes.string.isRequired,
                                orientation="horizontal"
                                anchorDirection="right"
                                openDirection="down"
                                verticalHeight={450}
                                numberOfMonths={1}
                                small={true}
                                phrases={this._phrases}
                                placeholder=""
                                isOutsideRange={this._outsideRange}
                                displayFormat="DD/MM/YY"
                            />
                        </div>
                        <div className="col-4">
                            <label className="py-2">Data fechamento redação</label>
                            <SingleDatePicker
                                date={this.state.dtRedacao !== null ? moment(this.state.dtRedacao) : null} // momentPropTypes.momentObj or null
                                onDateChange={date => this.onDateChangeRedacao(date)} // PropTypes.func.isRequired
                                focused={this.state.focusedRedacao} // PropTypes.bool
                                //array.map(item => novoItem = item) - atribuição de valor
                                onFocusChange={({ focused }) => this.setState({ focusedRedacao: focused })} // PropTypes.func.isRequired
                                id="dtRedacao" // PropTypes.string.isRequired,
                                orientation="horizontal"
                                anchorDirection="right"
                                openDirection="down"
                                verticalHeight={450}
                                numberOfMonths={1}
                                small={true}
                                phrases={this._phrases}
                                placeholder=""
                                isOutsideRange={this._outsideRange}
                                displayFormat="DD/MM/YY"
                            />
                        </div>

                        <div className="col-4">
                            <label className="py-2">Data entrega periódico</label>
                            <SingleDatePicker
                                date={this.state.dtEntrega !== null ? moment(this.state.dtEntrega) : null} // momentPropTypes.momentObj or null
                                onDateChange={date => this.onDateChangeEntrega(date)} // PropTypes.func.isRequired
                                focused={this.state.focusedEntrega} // PropTypes.bool
                                onFocusChange={({ focused }) => this.setState({ focusedEntrega: focused })} // PropTypes.func.isRequired
                                id="dtEntrega" // PropTypes.string.isRequired,
                                orientation="horizontal"
                                anchorDirection="right"
                                openDirection="down"
                                verticalHeight={450}
                                numberOfMonths={1}
                                small={true}
                                phrases={this._phrases}
                                placeholder=""
                                isOutsideRange={this._outsideRange}
                                displayFormat="DD/MM/YY"
                            />
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-12 text-right mt-2">
                            {this.state.isLoadingSalvarDatas ? (
                                <div className="spinner-border text-primary text-center" role="status" />
                            ) : (
                                <button className="btn btn-outline-success" onClick={this.salvarDatas} disabled={this.validarData()}>Salvar</button>
                            )}
                        </div>
                    </div>
                </ModalBody>
            </Modal >
        )

    }

}


export default ModalEditarEdicao;